export const CLASSROOM_CODE_ALPHABET = '0123456789ABCDEFGHJKMNPQRSTVWXYZ';
export const CLASSROOM_CODE_LENGTH = 6;
export const ASSISTANT_CODE_LENGTH = 8;

const CLASSROOM_CODE_RE = new RegExp(`^[${CLASSROOM_CODE_ALPHABET}]{${CLASSROOM_CODE_LENGTH}}$`);
const ASSISTANT_CODE_RE = new RegExp(`^[${CLASSROOM_CODE_ALPHABET}]{${ASSISTANT_CODE_LENGTH}}$`);

/** Keep only classroom-code characters (uppercase in the field) and cap length. */
export function filterClassroomCodeInput(raw: string): string {
  const allowed = new Set(CLASSROOM_CODE_ALPHABET);
  return raw
    .toUpperCase()
    .split('')
    .filter((character) => allowed.has(character))
    .join('')
    .slice(0, CLASSROOM_CODE_LENGTH);
}

export function normalizeClassroomCode(raw: string): string {
  return raw.trim().toUpperCase();
}

export function isValidClassroomCode(code: string): boolean {
  return CLASSROOM_CODE_RE.test(code);
}

export function normalizeAssistantCode(raw: string): string {
  return raw.trim().toUpperCase();
}

export function isValidAssistantCode(code: string): boolean {
  return ASSISTANT_CODE_RE.test(code);
}

/** Internal assistant route, or null when the slug is not a valid 8-char code. */
export function assistantChatPath(raw: string): string | null {
  const normalized = normalizeAssistantCode(raw);
  if (!isValidAssistantCode(normalized)) {
    return null;
  }
  return `/assistent/${encodeURIComponent(normalized)}`;
}

/** Absolute share URL for a published assistant code. */
export function assistantShareUrl(slug: string): string | null {
  const path = assistantChatPath(slug);
  if (!path) {
    return null;
  }
  return `${window.location.origin}${path}`;
}
